<template>
  <div @click="handleDownloadTemplate">
    <p>Download Template</p>

    <!-- Download Icon Here -->
    <span>
      <svg
        width="12"
        height="13"
        viewBox="0 0 12 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.64645 8.89002C5.84171 9.08528 6.15829 9.08528 6.35355 8.89002L9.53553 5.70804C9.7308 5.51278 9.7308 5.1962 9.53553 5.00093C9.34027 4.80567 9.02369 4.80567 8.82843 5.00093L6 7.82936L3.17157 5.00093C2.97631 4.80567 2.65973 4.80567 2.46447 5.00093C2.2692 5.1962 2.2692 5.51278 2.46447 5.70804L5.64645 8.89002ZM5.5 0L5.5 8.53647H6.5L6.5 0L5.5 0Z"
          fill="black"
        />
        <line x1="12" y1="11.6836" y2="11.6836" stroke="black" />
      </svg>
    </span>
  </div>
</template>

<script>
export default {
  name: 'DownloadTemplate',

  methods: {
    handleDownloadTemplate() {
      window.open(
        `https://gemnote-website-assets.s3.us-west-2.amazonaws.com/Recipient-list-CSV-template.csv`
      )
    }
  }
}
</script>

<style lang="scss" scoped>
div {
  cursor: pointer;
  display: flex;
  align-items: center;
  color: #25282a;

  p {
    font-size: 0.813rem;
    font-weight: bold;
    text-decoration: underline;
  }

  span {
    margin: 0.25rem 0 0 0.25rem;
  }
}
</style>
